import React from "react";
import {
    Column,
    DataGrid,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    ColumnHeaderFilter,
    Selection,
} from "devextreme-react/data-grid";
class LookUpLotGrid extends React.Component {
    constructor(props) {
        super(props);
        this.selectionChanged = this.selectionChanged.bind(this);
    }
    selectionChanged = ({ selectedRowsData }) => {
        const selectedData = selectedRowsData[0];
        if (selectedRowsData.length === 1) 
            this.props.parentCallback(selectedData.lotcode);
    };
    render() {
        return (
            <div>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    noDataText="No Data"
                    dataSource={this.props.databanck}
                    showBorders={true}
                    className={this.props.selectedItems?.length>0?"Popup-GridHeightAccordianOpen":"Popup-GridHeightAccordianClose"}
                    hoverStateEnabled={true}
                    allowColumnResizing={true}
                    allowColumnReordering={false}
                    rowAlternationEnabled={false}
                    onSelectionChanged={(e) => this.selectionChanged(e)}
                    focusedRowEnabled={true}
                    showRowLines={true}
                    showColumnLines={false}
                    keyExpr={"rowid"}
                >
                    <ColumnHeaderFilter />
                    <LoadPanel enabled={true} />
                    <Selection mode="single" />
                    <Paging defaultPageSize={10} />
                    <Sorting visible={false} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 50, 300, 500, 1000]}
                        showNavigationButtons={true}
                    />
                    <Column dataField="lotcode" caption="Lot"></Column>
                    <Column dataField="lotdescription1" caption="Lot Description - 1"></Column>
                    <Column dataField="lotdescription2" caption="Lot Description - 2"></Column>
                    <Column dataField="available" caption="Available"></Column>
                </DataGrid>
            </div>
        );
    }
}
export default LookUpLotGrid;